import classNames from 'classnames'
import React from 'react'

import './styles.scss'

const ColoredCheckbox = ({
  className,
  color = '#13682B',
  width = 24,
  height = 24,
  checked,
  onCheckedChange = () => {},
}) => {
  return (
    <>
      <If condition={checked}>
        <svg
          className={classNames('colored-checkbox', className)}
          onClick={() => onCheckedChange(false)}
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          fill="none"
          viewBox={`0 0 ${width} ${height}`}
          style={{ width, height }}
        >
          <path
            fill={color}
            d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
          />
        </svg>
      </If>
      <If condition={!checked}>
        <div
          onClick={() => onCheckedChange(true)}
          className={classNames('colored-checkbox colored-checkbox--unchecked', className)}
          style={{ width: width - 6, height: height - 6, borderColor: color, margin: 3 }}
        />
      </If>
    </>
  )
}

export default ColoredCheckbox
